import React from "react";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import { Grid } from "@mui/system";
import footer from "../../assets/css/Footer.module.scss";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IoMdPin } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import Logo from "../../assets/img/new-logo.png";
import { Link } from "react-router-dom";
import { isMobileOnly } from "react-device-detect";

const Footer = () => {
  return (
    <section className={footer.footerSection}>
      <Grid container spacing={2} className="customeContainer">
        <Grid size={{ xs: 12, md: 6 }}>
          <div className={footer.FtCompTitle}>
            <Link to="/">
              <img src={Logo} className={footer.ftLogo} alt="logo" />
            </Link>

            {isMobileOnly ? (
              ""
            ) : (
              <>
                <p>
                  Associated International Brokers, Inc AIB is a premier
                  brokerage specializing in Jewelers Block Insurance, offering
                  tailored risk solutions for jewelers, wholesalers,
                  manufacturers, retailers, art galleries, and pawnshops
                  worldwide.
                </p>
                <Link
                  to="/about-us"
                  sx={{
                    color: "#fff",
                    display: "block",
                    mt: 1,
                    width: "max-content",
                  }}
                >
                  Read More
                </Link>
              </>
            )}
            {/* <Box sx={{ display: "flex", gap: 3, mt: 2 }}>
                            <img src={FbIcon} />
                            <img src={InstaIcon} />
                            <img src={TwitIcon} />
                            <img src={LinkdIcon} />
                        </Box> */}
          </div>
        </Grid>

        {/* Mobile View Accordion */}
        <Grid
          size={{ xs: 12, md: 3 }}
          sx={{ display: { xs: "block", md: "none" } }}
          className={footer.Linktitle}
        >
          <Accordion
            sx={{ bgcolor: "transparent", color: "#fff" }}
            className="footer_accordion"
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
            >
              <Typography variant="h6">Quick Links</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <ul className={footer.Qlinks}>
                <li>
                  <Link
                    to="/jewelers-block"
                    sx={{ color: "#fff", display: "block", mt: 1 }}
                  >
                    Jewelers Block
                  </Link>
                </li>
                <li>
                  <Link
                    to="/login"
                    sx={{ color: "#fff", display: "block", mt: 1 }}
                  >
                    Proposal
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about-us"
                    sx={{ color: "#fff", display: "block", mt: 1 }}
                  >
                    About Us
                  </Link>
                </li>
                {/* <li>
                  <Link
                    to="/jewelers-block-policy"
                    sx={{ color: "#fff", display: "block", mt: 1 }}
                  >
                    Jewelers Block Policy
                  </Link>
                </li> */}
                <li>
                  <Link
                    to="/contact-us"
                    sx={{ color: "#fff", display: "block", mt: 1 }}
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </AccordionDetails>
          </Accordion>
        </Grid>

        {/* Desktop View */}
        <Grid
          size={{ xs: 12, md: 3 }}
          sx={{ display: { xs: "none", md: "block" } }}
          className={footer.Linktitle}
        >
          <Typography variant="h6">Quick Links</Typography>
          <ul className={footer.Qlinks}>
            <li>
              <Link
                to="/jewelers-block"
                sx={{ color: "#fff", display: "block", mt: 1 }}
              >
                Jewelers Block
              </Link>
            </li>
            <li>
              <Link to="/login" sx={{ color: "#fff", display: "block", mt: 1 }}>
                Proposal
              </Link>
            </li>
            <li>
              <Link
                to="/about-us"
                sx={{ color: "#fff", display: "block", mt: 1 }}
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/jewelers-block-policy"
                sx={{ color: "#fff", display: "block", mt: 1 }}
              >
                Jewelers Block Policy
              </Link>
            </li>
            <li>
              <Link
                to="/contact-us"
                sx={{ color: "#fff", display: "block", mt: 1 }}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </Grid>

        <Grid size={{ xs: 12, md: 3 }} className={footer.Linktitle}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Get In Touch
          </Typography>
          <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
            <IoMdPin />
            <p>
              608 5th Ave, Suite 903
              <br /> New York NY 10020
              {/* 608 Fifth Avenue Suite #903 <br /> New York, NY 10020 */}
            </p>
          </Box>
          <Box
            sx={{ display: "flex", gap: 1, mb: 1 }}
            onClick={(e) => {
              window.location.href = `tel:+12124895300`;
            }}
          >
            <FaPhoneAlt /> <p> +1 (212)-489-5300 </p>
          </Box>
          <Box
            sx={{ display: "flex", gap: 1, mb: 1 }}
            onClick={(e) => {
              window.location.href = `mailto:office@aibnewyork.com`;
            }}
          >
            <IoMail /> <p> office@aibnewyork.com </p>
          </Box>
        </Grid>
      </Grid>

      <div className={footer.btmFooter}>
        <span>

          <a style={{ color: 'inherit', textTransform: 'capitalize' }} href="https://belgiumwebnet.com/" target="_blank" aria-label="bw" rel="noreferrer">   © All Rights Reserved. Designed & Developed by Belgium Webnet Inc. </a>

        </span>
      </div>
    </section>
  );
};

export default Footer;
